import React, { useState, useEffect } from "react";
const NoSSR = (props) => {
    const { children, onSSR = null } = props;
    const [canRender, setCanRender] = useState(false);
    useEffect(() => {
        setCanRender(true);
    }, [setCanRender]);
    return React.createElement(React.Fragment, null, canRender ? children : onSSR);
};
export default NoSSR;
